import React, { useState, useEffect } from "react"
import { CardBody, Card, Col, Row } from "reactstrap"
import moment from "moment"

const ViewImage = ({ item, setisGallery, setphotoIndex,dataKey }) => {
  const [imageLoaded, setImageLoaded] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => {
      setImageLoaded(true)
    }, 500) // Adjust the delay time as needed

    // Clear the timer when the component unmounts
    return () => clearTimeout(timer)
  }, [])

  return (
    <Row>
      {/* {!dataKey &&  */}
      <>
      {(item || [])?.map((screens, key) => (
        <Col xl="2" sm="4" key={"_col_" + key}>
          <Card>
            <CardBody>
              <div className="product-img position-relative d-flex">
                {imageLoaded && (
                  <img
                    src={screens.imagePath}
                    onClick={() => {
                      setisGallery(true)
                      setphotoIndex(key)
                    }}
                    style={{ borderRadius: "5px" }}
                    className="img-fluid mx-auto d-block"
                    alt={`Screen ${key}`}
                  />
                )}
              </div>{" "}
              <div className="mt-2 text-center">
                {moment(new Date(screens.capturetime)).format("HH:mm:ss")}
              </div>
            </CardBody>
          </Card>
        </Col>
      ))}
      </>
{/* } */}
    </Row>
  )
}

export default ViewImage
